import { isUndefined } from 'lodash';


export const isOdReturnExist = (odDeal, { year, month }, station) => {
    for (const _station in odDeal) {
        if (odDeal[_station][year]
        && odDeal[_station][year][month]
        && odDeal[_station][year][month][_station]
        && odDeal[_station][year][month][_station][station]) {
            const deal = odDeal[_station][year][month][_station][station];
            if (deal) return true;
        }
    }
    return false;
};
// 計算的是從他站借，到此站還得數量
// total: 要不要回傳總交易數
export const odDealReturnCount = (odCount, selectYearMonth, station, total = false) => {
    const returnCount = {};
    let totalNum = 0;
    if (station !== 'all') {
        for (const _station in odCount) {
            if (odCount[_station]) {
                for (const i in selectYearMonth) {
                    if (selectYearMonth[i]) {
                        const item = selectYearMonth[i];
                        const { year, month } = item;
                        if (odCount[_station][year]
                && odCount[_station][year][month]
                && odCount[_station][year][month][_station]
                && odCount[_station][year][month][_station][station]) {
                            const deal = odCount[_station][year][month][_station][station];
                            if (deal) {
                                if (isUndefined(returnCount[_station])) returnCount[_station] = deal;
                                else returnCount[_station] += deal;
                                totalNum += deal;
                            }
                        }
                    }
                }
            }
        }
    }
    if (total) return { returnCount, totalReturnCount: totalNum };
    return returnCount;
};
// total: 要不要回傳總交易數
export const odDealBorrowCount = (odCount, selectYearMonth, station, total = false) => {
    const data = {};
    let totalNum = 0;
    if (station !== 'all') {
        selectYearMonth.forEach((item) => {
            const { year, month } = item;
            if (!isUndefined(odCount[station])) {
                if (odCount[station][year]
            && odCount[station][year][month]
            && odCount[station][year][month][station]) {
                    const thisData = odCount[station][year][month][station];
                    for (const key in thisData) {
                        // if data didn't has this key, add it. else ++
                        if (isUndefined(data[key])) data[key] = thisData[key];
                        else data[key] += thisData[key];

                        totalNum += thisData[key];
                    }
                }
            } else {
                return false;
            }
        });
    }
    if (total) return { borrowCount: data, totalBorrowCount: totalNum };
    return data;
};
